import React from 'react';
import Background from '../../images/Background.png'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import axios from 'axios';
import { withRouter } from 'react-router'
import { Progress } from 'antd';
import Logo from '../../images/logos/trackerapps.png'
import googleplay from '../../images/googleplay.png';
import appstore from '../../images/appstore.png';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

class ThankYou extends React.Component {

  render() {
    const { t, products } = this.props
    return (
      <div style={styles.background}>
        <div style={{ width: 'max-content', margin: '0 auto' }}>
          <div>
            <img src={Logo} alt="Skilltracker logo" style={{ width: '183px', margin: '0 auto', marginTop: 50, display: 'block' }} />
            <h1 style={{ marginTop: 50, color: 'white', fontSize: 30 }}>{t('Thank you for registering to Tracker Apps!')}</h1>
            <h3 style={{ color: 'white', textAlign: 'center', marginBottom: 30 }}>{t('Welcome aboard! Please download our app:')}</h3>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <a href="https://itunes.apple.com/my/app/skill-tracker/id1390479942?mt=8">
                <img
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '200px'
                  }}
                  src={appstore}
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.skilltracker">
                <img
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '207px'
                  }}
                  src={googleplay}
                />
              </a>
            </div>
            <Link to="/"><h3 style={{ color: 'white', textAlign: 'center', marginTop: 30, fontSize: 22 }}>Or <span style={{ textDecoration: 'underline' }}><strong>Click Here</strong></span> to proceed to the web app.</h3></Link>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  background: {
    backgroundImage: `url(${Background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100vh',
    width: '100vw',
    position: 'absolute'
  }
}

// export default compose(
//   translate(['view', 'nav'], { wait: true }),
// )(ThankYou)


const enhancer = compose(
  translate('lang'),
  firebaseConnect(props => {
    return ['/users'];
  }),
  connect(state => {
    return {
      auth: state.firebase && state.firebase.auth,
      profile: state.firebase && state.firebase.profile.profile,
      products: state.firebase && state.firebase.profile.profile.products
    };
  })
);
export default enhancer(ThankYou);



// WEBPACK FOOTER //
// ./src/containers/ThankYou/index.jsx